import { MenuMode } from '../../enums';
import { RefProperty } from '../../ref-property.model';
import { CollectionValuePresenterModel } from './collection-value-presenter-model';

export class UserStateDataPresenterModel {
  dateFormat?: CollectionValuePresenterModel;
  dateTimeFormat?: CollectionValuePresenterModel;
  firstLogin?: boolean;
  fontSize?: number;
  language?: RefProperty;
  layoutMode?: 'light' | 'dark';
  menuMode?: MenuMode;
  theme?: RefProperty;
  timeFormat?: CollectionValuePresenterModel;
  timeZone?: RefProperty;
  user?: RefProperty;
}
